import { render, staticRenderFns } from "./ComponentDataBoard.vue?vue&type=template&id=58e0553a&scoped=true"
import script from "./ComponentDataBoard.vue?vue&type=script&lang=js"
export * from "./ComponentDataBoard.vue?vue&type=script&lang=js"
import style0 from "./ComponentDataBoard.vue?vue&type=style&index=0&id=58e0553a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e0553a",
  null
  
)

export default component.exports